import React, { useMemo } from "react";
import styled from "styled-components";
import { ReleaseNoticeModalProps } from "../types";
import { FormattedMessage } from "react-intl";

const ReleaseNoticeModal: React.FC<ReleaseNoticeModalProps> = ({ onPublish, step, deliveryId, releaseDate }) => {
  const isDisabled = step <= 5;

  // Format release date to "December 22" format
  const formattedReleaseDate = useMemo(() => {
    if (!releaseDate) return null;
    const date = new Date(releaseDate);
    return date.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
    });
  }, [releaseDate]);

  return (
    <ModalWrapper>
      <ModalText>
        <FormattedMessage
          id="NewRelease.Platform.PublishReleaseText1"
          defaultMessage="Release scheduled for "
        />
        {formattedReleaseDate || "—"}
        <FormattedMessage
          id="NewRelease.Platform.PublishReleaseText3"
          defaultMessage=" Some platforms may experience delays if metadata is incorrect."
        />
        <br />
        <FormattedMessage
          id="NewRelease.Platform.PublishReleaseText2"
          defaultMessage="Please check your release after publication"
        />
      </ModalText>
      <PublishButton onClick={onPublish} disabled={isDisabled}>
        <FormattedMessage
          id="NewRelease.Platform.PublishRelease"
          defaultMessage="Publish release"
        />
      </PublishButton>
    </ModalWrapper>
  );
};

const ModalWrapper = styled.div`
  margin-top: 18px;
  background-color: #ffffff;
  padding: 16px 24px 16px 22px;
  border-radius: 25px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  /* Mobile: text full width, button below */
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`;

const ModalText = styled.div`
  font-family: SF Pro Display;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  color: #00000080;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const PublishButton = styled.button<{ disabled?: boolean }>`
  width: 209px;
  height: 46px;
  border-radius: 10px;
  font-family: Outfit;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
  border: none;
  background-color: ${({ disabled }) => (disabled ? "#6777FF80" : "#6777FF")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  transition: background-color 0.3s;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export default ReleaseNoticeModal;
